import { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Checkbox = ({
  options,
  disabled = false,
  defaultValue = [],
  onChange = null,
  error,
}) => {
  const [value, setValue] = useState(defaultValue || []);

  const handleChange = (event, checkboxValue) => {
    let newValue = [...value];
    if (event.target.checked) {
      newValue.push(checkboxValue);
    } else {
      newValue = newValue.filter(v => v !== checkboxValue);
    }

    setValue(newValue);
    if (onChange) onChange(newValue);
  };

  return (
    <div style={{ position: 'relative' }}>
      {_.map(options, (option, i) => (
        <div key={i} className="checkbox">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              name={`${option.value}`}
              value={option.value}
              checked={value.includes(option.value)}
              onChange={event => handleChange(event, option.value)}
              disabled={disabled}
              style={disabled ? { cursor: 'not-allowed' } : {}}
            />
            <div className="checkbox-svg" />
          </div>
          <p
            className={value.includes(option.value) ? 'label-selected' : null}
            style={disabled ? { color: '#aaaaaa' } : {}}
          >
            {option.label}
          </p>
        </div>
      ))}
      {error && <p className="onboarding-error">{error}</p>}
    </div>
  );
};

Checkbox.propTypes = {
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.array,
  onChange: PropTypes.func,
};

export default Checkbox;
